/**
 * Approximate count of active refine-search criteria for vehicle results (URL / searchOptions shape).
 * Used for mobile "Filters N" badge; excludes sort, pagination, and lease duration.
 *
 * @param {object} options - searchOptions
 * @param {{ makeFacetOptionCount?: number }} [meta] - When `makeFacetOptionCount` is 0 or 1, the mobile refine hub
 *   hides the Make row (same as RefineSearchContainer `mobileHubShowMake`). The make is still in URL/state, so if
 *   the raw count includes a `pair[].make`, subtract 1 so the badge matches what the user can edit in the drawer.
 */
export function countVehicleResultSearchFilters(options, meta = {}) {
  if (!options || typeof options !== 'object') return 0;
  let n = 0;
  const pairs = options.pair;
  if (Array.isArray(pairs)) {
    pairs.forEach((p) => {
      if (p && p.make) n += 1;
      if (Array.isArray(p?.models) && p.models.length) n += p.models.length;
    });
  }
  const listKeys = [
    'vehicleFueltype',
    'vehicleBodytype',
    'cabType',
    'vehicleCategory',
    'vehicleSeats',
    'vehicleDriveTrain',
    'vehicleTransmission'
  ];
  for (const k of listKeys) {
    const v = options[k];
    if (Array.isArray(v) && v.length) n += v.length;
  }
  if (options.vehicleMinRRP != null || options.vehicleMaxRRP != null) n += 1;
  if (options.minBudget != null || options.maxBudget != null) n += 1;

  const { makeFacetOptionCount } = meta;
  if (makeFacetOptionCount != null && makeFacetOptionCount <= 1 && Array.isArray(pairs) && pairs.some((p) => p && p.make)) {
    n = Math.max(0, n - 1);
  }

  return n;
}
